<!-- 执行表格提醒配置 -->
<template>
  <div class="dept-notification atb-flex atb-flex-column atb-full-height">
    <div class='atb-content-bg atb-flex atb-flex-column atb-full-height'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" v-on:keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="部门" prop="deptNo">
            <DeptSelect v-model="searchParam.deptNo" :isDisableDeleted="false" />
          </el-form-item>
          <el-form-item label="人员">
            <selecter v-model="searchParam.wkNo" placeholder="输入工号或姓名查询"></selecter>
          </el-form-item>
          <el-form-item label="消息提醒接收人">
            <selecter v-model="searchParam.recipientNo" placeholder="输入工号或姓名查询"></selecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button type="add" @click="add">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="exportExcel">导出</el-button>
          </el-form-item>
          <!-- <el-form-item v-if="$auth(that, 'Import')"> -->
          <el-form-item>
            <el-button type="downloadTemplate" @click="downloadTemplate" style="width: 100px!important;">下载导入模板</el-button>
          </el-form-item>
          <el-form-item>
            <el-upload ref="file" :http-request="uploadFile" :multiple="false" :show-file-list='false'>
              <el-button type="import">导入</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table class='atb-table header-table edit-table' border='inner' height='100%' auto-resize resizable :seq-config="{seqMethod}"
          :data="tableData" ref="dataTable" @checkbox-change="handledSelectChange" @checkbox-all="selectAllEvent" @cell-click="expandRow">
          <!-- <vxe-table-column type='checkbox' width='40'></vxe-table-column> -->
          <vxe-table-column type="seq" title="NO." width='60'></vxe-table-column>
          <vxe-table-column field="deptName" title="部门" width="200"></vxe-table-column>
          <vxe-table-column field="wkNames" title="人员" min-width="200"></vxe-table-column>
          <vxe-table-column field="recipientList" title="消息提醒接收人" min-width='200'>
            <template #default="{ row }">{{formatName(row.recipientList)}}</template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed="right" width='120' class-name='operation'>
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='edit({ row: scope.row })'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                <i class='icon-close delete' @click.stop='deleteTip(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager background :current-page.sync="page.PageIndex" :page-size.sync="page.PageSize" :total="total"
          height="100%" @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']">
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>此操作会删除对应的工作项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="commonDialog" :title="dialogContent.title" width="500px" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="editRow" @submitSuccess="getList(1)"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import tableMixin from '@/mixins/table.mixin'
export default {
  name: 'DeptNotification',
  mixins: [tableMixin],
  components: {
    Edit: () => import('./Edit'),
    selecter: () => import('@/component/global/customerSelect'),
    DeptSelect: () => import('@/component/global/DeptSelect'),
  },
  data() {
    return {
      downloadUrl: process.env.VUE_APP_PUBLICPATH + "files/执行表格提醒配置导入模板.xlsx",
      that: this,
      showDelTip: false,
      row: {},

      searchParam: {wkNo: '', recipientNo: '', deptNo: ''},
      page: {
        PageIndex: 1,
        PageSize: 10,
      },
      total: 0,
      tableData: [],
      editRow: {},
    }
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    // 格式化序列号
    seqMethod({ rowIndex }) {
      return rowIndex + (this.page.PageIndex - 1) * this.page.PageSize + 1;
    },
    getList(page) {
      if(page) {
        this.page.PageIndex = page;
      }
      const pageParam = { ...this.page, ...this.searchParam };
      this.$ajax.get(this.$api.Identity.deptNotification.list, pageParam).then((res) => {
        const data = res.data.rows || [];
        const tableData = [];
        data.forEach(item => {
          const list = item.deptNotificationList || [];
          const wkNos = list.filter(w => w.dataType == 2);
          wkNos.sort((a, b) => {
            if (a.wkDeptNo < b.wkDeptNo) {
              return -1;
            } else {
              return 1;
            }
          });
          
          const dept = list.find(w => w.dataType == 1);
          const row = {};
          row.id = item.groupId;
          row.wkNos = [];
          if (wkNos && wkNos.length > 0) {
            row.wkList = wkNos.map(w => {return {wkNo: w.wkDeptNo, wkName: w.wkDeptName}});
            row.wkNames = wkNos.map(w => `${w.wkDeptName}(${w.wkDeptNo})`).join('，');
            row.wkNos = wkNos.map(w => w.wkDeptNo);
            row.recipientList = wkNos[0].recipientList;
            row.recipientWkNos = row.recipientList.map(w => w.wkNo);
          }
          if (dept) {
            row.deptName = dept.wkDeptName;
            row.departNo = dept.wkDeptNo;
            row.recipientList = dept.recipientList;
            row.recipientWkNos = row.recipientList.map(w => w.wkNo);
          }
          row.expandRowFlag = false;
          tableData.push(row);
        });
        this.tableData = tableData;
        this.total = res.data.total;
      });
    },
    handlePageChange({ currentPage }) {
      this.getList(currentPage);
    },
    add() {
      this.isEdit = false;
      this.editRow = {
        departNo: '',
        wkNos: [],
        recipientWkNos: [],
      };
      this.dialogContent = {
        title: '新增',
        componentName: 'Edit'
      }
      this.$refs.commonDialog.show()
    },
    edit({row}) {
      this.isEdit = true;
      this.editRow = typeof (row) == 'object' ? row || {} : {};
      this.dialogContent = {
        title: '编辑',
        componentName: 'Edit'
      }
      this.$refs.commonDialog.show()
    },

    exportExcel() {
      this.$ajax.post(this.$api.Identity.deptNotification.exportFile, { ...this.searchParam, ...this.page }).then((res) => {
        if (res.code === 0) {
          this.$router.push({
            path: '/manage/export-task/index',
          });
        }
        // if (res.data.type == 'application/json') {
        //   var reader = new FileReader();
        //   reader.onload = () => {
        //     var content = reader.result;//内容就在这里
        //     let json = JSON.parse(content)
        //     this.$message.error(json.message)
        //   };
        //   reader.readAsText(res.data);
        // } else {
        //   const filename = '执行表格提醒配置'
        //   const filetype = 'xlsx'
        //   let data = res.data;
        //   let url = window.URL.createObjectURL(data)
        //   let a = document.createElement('a')
        //   document.body.appendChild(a)
        //   a.href = url
        //   a.download = filename + '.' + filetype
        //   a.click()
        //   window.URL.revokeObjectURL(url)
        // }
      }).catch(() => { })
    },
    downloadTemplate() {
      window.location.href = this.downloadUrl;
    },
    uploadFile({ file }) {
      const params = new FormData();
      params.append('excelfile', file);
      this.$ajax.post(this.$api.Identity.deptNotification.importFile, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
        // if (res.code === 0) {
        //   this.$router.push({
        //     path: '/manage/export-task/index',
        //   });
        // }
        if (res.code === 0) {
          this.$message.success('上传成功');
          this.getList(1);
        }
      });
    },
    deleteTip(row) {
      this.showDelTip = true;
      this.row = row;
    },
    del() {
      if (this.row) {
        this.$ajax.get(this.$api.Identity.deptNotification.delete + '?id=' + this.row.id).then(() => {
          this.$message.success('删除成功');
          this.getList(1);
        }).finally(() => {
          this.showDelTip = false;
        });
      }
    },
    expandRow({row}) {
      row.expandRowFlag = !row.expandRowFlag;
      this.$refs.dataTable.updateData(this.tableData);
    },
    formatName(names = []) {
      return names.map(item => `${item.wkName}(${item.wkNo})`).join('，');
    }
  }
}
</script>
<style scoped lang='scss'>
.dept-notification {
  .link-ele {
    margin: 0 5px;
  }

  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
  }

  ::v-deep .vxe-table--render-default.vxe-editable.size--medium .vxe-body--column {
    height: 48px;
  }

  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column.col--ellipsis {
    height: 48px;
  }

  .el-button--import {
    background-color: #def6e8;
    border-color: #def6e8;
    color: #0dcc82;
  }

  ::v-deep .el-button--downloadTemplate {
    width: 100px !important;
    background-color: #def6e8;
    border-color: #def6e8;
    color: #0dcc82;
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px!important;
    text-align: center;
    h2 {
      font-size: 18px;
      color: #4a5150;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: #687371;
    }
  }
}
</style>
